<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Coupons</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="couponCode" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.couponCode }}</td>
        <td class="text-xs-left">{{ props.item.lifeSpan }}</td>
        <td class="text-xs-left">{{ props.item.lifeUsed }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review remove @review="doReview(props.item)" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-card-text>
      <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()">
        Permit Coupon
        <v-icon right>mdi-ticket-percent</v-icon>
      </v-btn>
    </v-card-text>
    <v-dialog v-model="addCouponDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Permit Coupon for Promotion</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 v-if="newCoupon">
                <v-text-field :label="labels.couponCode" v-model="promoCouponForm.couponCode" :error-messages="errors.collect('couponCode')" v-validate="'required|param|max:20'" data-vv-name="couponCode" :data-vv-as="labels.couponCode"></v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{labels.couponCodeQuery}}</v-subheader>
                <div class="title">{{promoCouponForm.couponCode}}</div>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field v-int-mask="{intScale: 9}" v-model="promoCouponForm.lifeSpan" :label="labels.lifeSpan" type="tel" :error-messages="errors.collect('lifeSpan')" data-vv-name="lifeSpan" :data-vv-as="labels.lifeSpan" v-validate="'required|numeric|max_value:999999999|min_value:0'"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field v-int-mask="{intScale: 9}" v-model="promoCouponForm.lifeUsed" :label="labels.lifeUsed" type="tel" :error-messages="errors.collect('lifeUsed')" data-vv-name="lifeUsed" :data-vv-as="labels.lifeUsed" v-validate="lifeUsedValidation"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Coupon?
      <div class="title">{{deletePromoCoupon}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Coupon Code', align: 'left', value: 'couponCode', sortable: false },
        { text: 'Life Span', align: 'left', value: 'lifeSpan', sortable: false },
        { text: 'Life Used', align: 'left', value: 'lifeUsed', sortable: false },
        TableConst.tableActionHeader
      ],
      labels: {
        couponCode: 'Coupon Code*',
        couponCodeQuery: 'Coupon Code',
        lifeSpan: 'Life Span*',
        lifeUsed: 'Life Used*'
      },
      promoCouponForm: {
        promotion: undefined,
        couponCode: undefined,
        lifeSpan: undefined,
        lifeUsed: undefined,
        revision: undefined
      },
      totalItems: 0,
      loading: false,
      items: [],
      newCoupon: false,
      addCouponDialog: false,
      promptRemove: false,
      selectedPromoCoupon: undefined,
      deletePromoCoupon: ''
    }
  },
  computed: {
    lifeUsedValidation() {
      const result = 'required|numeric|max_value:999999999|min_value:0|promoCoupon_lifeUsed_lifeSpan:' + this.promoCouponForm.lifeSpan
      return result
    }
  },
  methods: {
    async doInit() {
      this.promoCouponForm.promotion = this.promotion
      await this.queryPromotionCoupons()
    },
    async queryPromotionCoupons() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCoupons
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionCoupon) => {
                const convertPromotionCoupon = {
                  promotion: promotionCoupon.promotion,
                  promotionDesc: promotionCoupon.promotionDesc,
                  couponCode: promotionCoupon.couponCode,
                  lifeSpan: promotionCoupon.lifeSpan,
                  lifeUsed: promotionCoupon.lifeUsed,
                  revision: promotionCoupon.revision
                }
                this.items.push(convertPromotionCoupon)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doReview(data) {
      this.promoCouponForm.couponCode = data.couponCode
      this.promoCouponForm.lifeSpan = data.lifeSpan
      this.promoCouponForm.lifeUsed = data.lifeUsed
      this.promoCouponForm.revision = data.revision
      this.addCouponDialog = true
      this.newCoupon = false
    },
    doSave() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newCoupon) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.promoCouponForm.couponCode = undefined
      this.promoCouponForm.lifeSpan = undefined
      this.promoCouponForm.lifeUsed = undefined
      this.addCouponDialog = true
      this.newCoupon = true
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCouponCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoCouponForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryPromotionCoupons()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCouponUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.promoCouponForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.doClose()
            // Fetch list again
            this.queryPromotionCoupons()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doClose() {
      this.resetMessages()
      this.promoCouponForm.couponCode = undefined
      this.promoCouponForm.lifeSpan = undefined
      this.promoCouponForm.lifeUsed = undefined
      this.addCouponDialog = false
      this.newCoupon = false
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedPromoCoupon = data
        this.deletePromoCoupon = data.couponCode + ', Life: ' + data.lifeUsed + '/' + data.lifeSpan
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCouponDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          promotion: this.promotion,
          couponCode: this.selectedPromoCoupon.couponCode
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryPromotionCoupons()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.$validator.extend('promoCoupon_lifeUsed_lifeSpan', {
      getMessage(field, args) {
        return `Life Used must be lesser than Life Span.`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var lifeSpan = args[0]
          if (lifeSpan) {
            if (value >= lifeSpan) return false
            else return true
          } else return true
        } else return true
      }
    })
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
